import { all, put } from "redux-saga/effects";

import {
  fetchMessages,
  fetchNotices,
  fetchSchools,
  fetchTerms
} from "state/teachers/actions"

/**
 * Run all fetch APIs at once.
 */
export default function* fetchAllSaga() {
  
  const fetchActions = [
    fetchMessages(),
    fetchNotices(),
    fetchSchools(),
    fetchTerms()
  ];
  
  yield all(fetchActions.map(action => put(action)));
  
}



// WEBPACK FOOTER //
// ./src/state/teachers/sagas/fetchAll.js